import {useEffect, useState} from 'react';
import classes from "./App.module.scss";
import Content from "./components/DashboardLayout/Content";
import {useDispatch, useSelector} from "react-redux";
import {logIn} from "./store/reducers/LoginReducer/LoginReducer";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {TokenService} from "./api/tokenService";
import {AuthService} from "./api/authService";
import {useLocation, useNavigate} from "react-router-dom";
import {userService} from "./api/userService";
import Login from "./components/Pages/Forms/Login";
import errorMessage from "./const/Tost";
import Loader from "./components/common/Loader";

function App(){
    const dispatch = useDispatch();
    const userInfo = useSelector(state => state.login);
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    const [enteredValues, setEnteredValues] = useState({
        "email": '',
        "password": ''
    });

    const LogInHandler = (value) => {
        setEnteredValues(value);
    };

    useEffect(() => {
        if (userInfo?.loggedIn){
            localStorage.setItem('lastPath', location.pathname);
        }
    }, [location.pathname, userInfo?.loggedIn]);

    useEffect(() => {
        const autoLogin = async() => {
            try{
                await AuthService.checkAuth().then(res => {
                    if (res?.data){
                        TokenService.saveToken(res?.data.accessToken);
                        if (res?.data?.user?.id){
                            userService.getUserInfo(res?.data?.user?.id).then(response => {
                                if (response?.data){
                                    dispatch(logIn(response?.data?.user ? response?.data?.user : response?.data));
                                    const lastPath = localStorage.getItem('lastPath') || '/home';
                                    navigate(lastPath);
                                }
                            });
                        }
                    }
                });
            } catch(error){
                errorMessage(error, error?.response?.data?.message);
            } finally{
                setIsLoading(false);
            }
        };

        autoLogin();
    }, []);


    useEffect(() => {
        const fetchData = async() => {
            if (enteredValues.email && enteredValues.password){
                setIsLoading(true);
                await AuthService.login(enteredValues).then(response => {
                    if (response?.data){
                        TokenService.saveToken(response.data.accessToken);
                        dispatch(logIn(response?.data?.user))
                        navigate('/home')
                    }
                }).finally(() => setIsLoading(false));
            }
        };

        fetchData();
    }, [enteredValues, dispatch]);

    return (
        <div className={classes.App}>
            {isLoading ? (
                <Loader/>
            ) : (
                userInfo?.loggedIn ? (
                    <>
                        <Content/>
                    </>
                ) : (
                    <Login onChange={LogInHandler}/>
                )
            )}
            <ToastContainer/>
        </div>
    );
}

export default App;